//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal'
import alOverallHeader from '../components/al-overallHeader.vue'
import alOverallFooter from '../components/al-overallFooter.vue'
import HeaderMeterage from '../components/layout/HeaderMeterage.vue'
import FooterMeterage from '../components/al-overallFooter.vue'
import Courier from '~/components/Courier'

export default {
    middleware: 'appData',
    components: {
        alOverallFooter,
        alOverallHeader,
        HeaderMeterage, FooterMeterage,
        Courier
    },
    data() {
        return {
            navigationType: '',
            headerType: '',
            footerType: ''
        }
    },
    mounted() {
        this.navigationType = localStorage.getItem('navigationType')
        if (this.navigationType == 'jiliang') {
            this.headerType = 'HeaderMeterage'
            this.footerType = 'FooterMeterage'
            document.title = '现代先进测量体系服务平台'
        } else {
            this.headerType = 'alOverallHeader'
            this.footerType = 'alOverallFooter'
        }
        if (
            this.$router.currentRoute.path.includes('/achievement') ||
            this.$router.currentRoute.path.includes('/Intermediary') ||
            this.$router.currentRoute.path.includes('/demandDashboard/dashboard') ||
            this.$router.currentRoute.path.includes('/demandDashboard') ||
            this.$router.currentRoute.path.includes('/roadShow') ||
            this.$router.currentRoute.path.includes('/overall') ||
            this.$router.currentRoute.path.includes('/lasa')
        ) {
            this.showRightWidow = false
        }
        this.queryHis()
        this.$bus.$on('changeBar', this.changeBar)
    },
    methods: {
        changeBar(type) {
            if (type == 'jiliang') {
                this.navigationType = 'jiliang'
                localStorage.setItem('navigationType', 'jiliang')
                this.headerType = 'HeaderMeterage'
                this.footerType = 'FooterMeterage'
                document.title = '现代先进测量体系服务平台'
            } else {
                // this.navigationType = 'jiliang'
                // localStorage.setItem('navigationType', 'jiliang')
                this.navigationType = ''
                localStorage.setItem('navigationType', '')
                this.headerType = 'alOverallHeader'
                this.footerType = 'alOverallFooter'
            }
        },
        async queryHis() {
            const strCookie = document.cookie
            const cookies = strCookie.split(' ')
            let touristId = ''
            cookies.map(str => {
                if (str.includes('NW_TOURIST_ID')) {
                    const tempArr = str.split('=')
                    touristId = tempArr[1]

                    if (touristId.indexOf(';') > 0) {
                        touristId = touristId.substring(0, touristId.length - 1)
                    }
                    localStorage.setItem('TOURIST_ID', touristId)
                }
            })

            const { code, data } = await portal.selectHomePageActivityId({
                body: {
                    touristId
                }
            })

            if (code == '0000') {

                if (data == '202413602956578655') {
                    this.navigationType = 'jiliang'
                    localStorage.setItem('navigationType', 'jiliang')
                    this.headerType = 'HeaderMeterage'
                    this.footerType = ''
                    document.title = '现代先进测量体系服务平台'
                } else {
                    this.navigationType = ''
                    localStorage.setItem('navigationType', '')
                    this.headerType = 'alOverallHeader'
                    this.footerType = 'alOverallFooter'
                }
            }
        },
    }
}
